// Import core Firebase SDK
import { initializeApp } from "firebase/app";

// Import the Firebase services you plan to use
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration (from environment variables)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDCmoc-qZ2iy94hiyG9jso6InJsEdIbSS0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "easyshopi.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "easyshopi",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "easyshopi.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "114227685429",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:114227685429:web:375b9a345ef1ee14ee297c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
